import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';
const reqUrl = `${baseGrtURL}/api/grt-ai`;

export const url = {
    status: `${reqUrl}/course/status` //获取课件
};
//查询评阅状态
export function handleGetReviewStatus(data) {
    return hMacAjax.get(url.status, data);
}
